import { render } from "./activities-list.vue?vue&type=template&id=0cf2a5a2&ts=true"
import script from "./activities-list.vue?vue&type=script&lang=ts"
export * from "./activities-list.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__